import { LRUCache as e } from "./utils.mjs";
import { getDefaultVariant as t, getIconImport as n, hasVariants as r } from "../components/atoms/Icon/icons.map.mjs";
import { useEffect as i, useState as a } from "react";
//#region src/utils/hooks.tsx
var o = new e(100);
function s(e, s) {
	let [c, l] = a({ component: null }), [u, d] = a(!1), [f, p] = a(!1);
	return i(() => {
		if (l({ component: null }), d(!1), p(!1), !e) return;
		let i = e, a;
		a = r(i) ? s || t(i) : void 0;
		let c = a ? `${i}:${a}` : i;
		if (o.has(c)) {
			l({ component: o.get(c) });
			return;
		}
		let u = n(i, a);
		u ? (d(!0), u().then((e) => {
			let t = e.default;
			typeof t == "function" || t && typeof t == "object" && "$$typeof" in t ? (o.set(c, t), l({ component: t }), d(!1)) : (console.error(`Invalid icon component for "${i}". Expected function or React component, got:`, typeof t), p(!0), d(!1));
		}).catch((e) => {
			console.warn(`Failed to load icon "${i}":`, e), p(!0), d(!1);
		})) : p(!0);
	}, [e, s]), {
		component: c.component,
		isLoading: u,
		hasError: f
	};
}
//#endregion
export { s as useIconLoader };
